import React, { createContext, useContext, useState } from "react";
import { ZoneFilter } from "../types/ZoneFilter";

interface ZoneFilterContextType {
  zoneFilter: ZoneFilter;
  setZoneFilter: (zone: ZoneFilter) => void;
}

const ZoneFilterContext = createContext<ZoneFilterContextType | undefined>(
  undefined
);

export const ZoneFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [zoneFilter, setZoneFilter] = useState<ZoneFilter>("todos");

  return (
    <ZoneFilterContext.Provider value={{ zoneFilter, setZoneFilter }}>
      {children}
    </ZoneFilterContext.Provider>
  );
};

export const useZoneFilter = () => {
  const context = useContext(ZoneFilterContext);
  if (context === undefined) {
    throw new Error("useZoneFilter must be used within a ZoneFilterProvider");
  }
  return context;
};
